import { NodeProps, Position, Handle } from "reactflow";
import { FileText, FolderIcon } from "lucide-react";
import { useEffect, useState } from "react";

export const AccountNode = ({ data }: NodeProps) => {
  // Different colors for folders vs files
  const fileNodeColor = "#60a5fa"; // blue
  const folderNodeColor = "#f59e0b"; // amber
  const [mounted, setMounted] = useState(false);

  // Create animation effect when the node mounts
  useEffect(() => {
    const timer = setTimeout(() => {
      setMounted(true);
    }, 50);

    return () => clearTimeout(timer);
  }, []);

  // Determine if this is a folder node
  const isFolder = data.isParent;
  const nodeColor = isFolder ? folderNodeColor : fileNodeColor;

  return (
    <div
      className={`p-3 rounded-md shadow-md transition-all duration-300 ${
        isFolder ? "bg-amber-50" : "bg-white"
      }`}
      style={{
        border: `2px solid ${nodeColor}`,
        width: data.width || 200,
        opacity: mounted ? 1 : 0,
        transform: mounted ? "translateY(0)" : "translateY(10px)",
      }}
    >
      <Handle type="target" position={Position.Top} className="w-2 h-2" />
      <div className="flex items-center gap-2 mb-1">
        {isFolder ? (
          <div className="relative">
            <FolderIcon
              size={20}
              className="shrink-0 text-amber-500 transition-transform duration-300"
              style={{
                transform: data.isExpanded ? "rotate(0deg)" : "rotate(-90deg)",
              }}
            />
            {data.isExpanded && (
              <div className="absolute -top-1 -right-1 w-2 h-2 bg-green-500 rounded-full" />
            )}
          </div>
        ) : (
          <FileText size={16} className="shrink-0 text-blue-500" />
        )}
        <div className="font-mono text-xs">{data.code}</div>
      </div>
      <div
        className={`font-medium mb-1 ${isFolder ? "font-semibold" : ""}`}
        style={{
          display: "-webkit-box",
          WebkitLineClamp: 2,
          WebkitBoxOrient: "vertical",
          overflow: "hidden",
          textOverflow: "ellipsis",
          lineHeight: "1.2em",
          maxHeight: "2.4em",
        }}
      >
        {data.name}
      </div>
      <Handle type="source" position={Position.Bottom} className="w-2 h-2" />
    </div>
  );
};
